<template>
  <BRow class="mb-5">
      <BCol cols="1">
        <BButton class="back-button float-left mt-2" to="/standalone-snowplow">Back</BButton>
      </BCol>
      <BCol cols="8" class="text-center">
        <h1 class="title">
          <slot name="title"></slot>
        </h1>
      </BCol>
  </BRow>
  <BRow>
    <BCol cols="9">
      <BRow>
        <slot name="form"></slot>
      </BRow>
    </BCol>
    <BCol cols="3">
      <slot name="actions"></slot>
    </BCol>
  </BRow>
  <BRow>
    <div class="mb-3">
      <label for="Log" class="form-label">window.atgDataLayer</label>
      <textarea class="form-control" id="log" rows="10" readonly></textarea>
    </div>
  </BRow>
  <BRow>
    <div class="mb-3">
      <label for="scripts" class="form-label">Scripts</label>
      <textarea class="form-control" id="scripts" rows="3" readonly></textarea>
    </div>
  </BRow>
</template>
<script setup>
let interval;

const setLog = () => {
  const scripts = document.getElementById('scripts');
  if (scripts) {
    scripts.value = Array.from(document.querySelectorAll('script[async]'))
      .map(el => el.src)
      .join("\n");
    document.getElementById('log').value = Array.from(window.atgDataLayer)
      .reverse()
      .map(el => JSON.stringify(el))
      .join("\n");
  }
};

onMounted(() => {
  interval = setInterval(setLog, 100);
});

onBeforeRouteLeave(() => {
  clearInterval(interval);
});
</script>
